export { Auth } from "./Auth.js";
export { AuthApiError } from "./internal/httpClient.js";
export type {
  AuthInitConfig,
  AuthState,
  AuthStateChangeCallback,
  LoginCredentials,
  RefreshResponse,
  // Phase 2a — OAuth
  AuthorizeParams,
  AuthorizeQuery,
  AuthorizeResult,
  OAuthClient,
  OAuthTokenResponse,
  TokenExchangeRequest,
  // Phase 2b — Multi-Account & SSO
  AccountSummary,
  AccountsResponse,
  SwitchAccountRequest,
  SwitchAccountResponse,
  SetDefaultAccountRequest,
  SessionStatusResponse,
  // Phase 2c — Cross-Domain & Popup Login
  AuthFlow,
  CrossDomainConfig,
  PopupMessage,
  RedirectParams,
} from "./types.js";
export type { User, AuthTokens } from "@restaurant/shared";
